import { type MouseEventData } from '../external-types';
import { fabric } from 'fabric';
import { type IPoint } from 'fabric/fabric-impl';
import type Canvas from '../objects/Canvas';
import type StylusComment from './StylusComment';

class CommentDrawingBrush extends fabric.BaseBrush {
  constructor(
    private readonly canvas: Canvas,
    private readonly stylus: StylusComment
  ) {
    super();
  }

  onMouseDown(pointer: IPoint, eventData: MouseEventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return;
    }

    this.canvas.controller.actionSetStylusMenu(null);
    this.canvas.controller.actionCreateComment({ pointer });
  }

  onMouseMove() {}

  onMouseUp(eventData: MouseEventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return true;
    }
    this.stylus.drawingComplete();

    return false;
  }

  _render() {}
}

export default CommentDrawingBrush;
